module.exports = __webpack_public_path__ + "assets/img/db3d1d10e4076e5fd3874b5985b57598.png";